import { createRoot } from "react-dom/client";
import App from "./components/app/App";
import "./assets/cleanup.css";
import "./libs/string.extension";

import { Provider } from "react-redux";
import configureRedux from "./redux/configureRedux";
import environment from "./environment";
import { initAnalytics } from "./libs/amplitudeHelper";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

const initialState = {};
const store = configureRedux(initialState);
initAnalytics(environment.versionDescription);

// StrictMode desactivado: en dev con MUI v4 desordena la insercion de
// estilos JSS y rompe el layout. Reactivar al migrar a MUI v5.
(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: environment.launchDarkly.sdkKey
      ? environment.launchDarkly.sdkKey
      : "",
    options: {},
  });
  const container = document.getElementById("root");
  if (!container) throw new Error("Root element #root not found");
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <LDProvider>
        <App />
      </LDProvider>
    </Provider>
  );
})();
